import { Navigate } from 'react-router-dom';

function SettingsApp() {
  return <Navigate to="/apps/settings/account" replace />;
}

export default SettingsApp;
